import WhatsappTemplateIndex from "@/views/crm/marketing/whatsapp-template/Index.vue";
import WhatsappTemplates from "@/views/crm/marketing/whatsapp-template/List.vue";
import WhatsappTemplate from "@/views/crm/marketing/whatsapp-template/Item.vue";
import CloudApi from "./cloud-api";
import Extension from "./extension";

export default [
  {
    path: "whatsapp-templates",
    component: WhatsappTemplateIndex,
    children: [
      {
        path: "",
        name: "whatsapp-templates",
        component: WhatsappTemplates,
        meta: {
          label: "Templates",
          breadcrumbs: ["home", "whatsapp-templates"],
        },
      },
      {
        path: ":id",
        component: WhatsappTemplate,
        props: true,
        children: [
          {
            path: "",
            name: "whatsapp-template",
            props: true,
            meta: {
              label: "Template",
              breadcrumbs: ["home", "whatsapp-templates", "whatsapp-template"],
            },
          },
        ],
      },
    ],
  },
  ...CloudApi,
  ...Extension,
];
